import {useForm} from "react-hook-form";
import TeamForm from "../../../Components/Forms/Pages/HR/Team/TeamForm";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import { editTeam } from "../../../Services/HR/TeamService";
import LinearProgress from '@mui/material/LinearProgress';
import TablePageContext from "../../../Context/TablePageContext";
import DrawerContext from "../../../Context/DrawerContext";
import { getOrganisationUnits } from "../../../Services/HR/OrganisationUnitService";
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'name': {required: true},
    'organisationUnit': {required: true}
}

const EditTeam = (props) => {
    const {setDrawerTitle} = useContext(DrawerContext);
    const {showMessage} = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: props.data && props.data.length > 0 ? props.data[0] : undefined
    });
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [oragnisationUnit, setOrganisationUnit] = useState([]);

    useEffect(() => {
        setDrawerTitle(strings.pages.hr.team.editTeam.pageTitle);
    });

    useEffect(() => {
        fetch();
    }, [])

    const onSubmit = (data) => {
        setShowLoader(true);

        editTeam(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok){
                showMessage(strings.commonMessages.errorEditing, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.editingSuccessful, 'success');
            props.onFinish();
        });
    }

    const fetch = (term = '') => {
        getOrganisationUnits({term}).then(response =>{
            if (!response || !response.ok){
                return;
            }
            setOrganisationUnit(response.data.result);
        })
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <TeamForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                organisationUnits={oragnisationUnit} onChangeUserFilter={fetch}
                errors={errors} data={data} form={form} control={control}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()} />
        </Paper>
    </div>
}

export default EditTeam;